import { FC } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate as ReduxPersistGateProvider } from 'redux-persist/integration/react';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import {
  ThemeProvider as MuiThemeProvider,
  CssBaseline as MuiCssBaseline,
} from '@mui/material';
// eslint-disable-next-line max-len
import { LocalizationProvider as MuiDatePickersLocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import dateFnsEsLocale from 'date-fns/locale/es';

import {
  useLoadGoogleApis,
  useLoadGoogleTagManager,
  useLoadTawk,
} from '~hooks/index';
import store, { persitor } from '~store/index';
import { theme } from '~config/index';
import { appHistory } from '~config/history';
import SignalRProvider from '~contexts/SignalRContext';
import { SnackBarProvider } from '~components/index';
import AlertsProvider from '~contexts/AlertsProvider';
import AccessFeatureModalProvider from '~contexts/AccessFeatureModalContext';
import SubscriptionPaymentModalProvider from '~contexts/SubscriptionPaymentModalContext';
import BannersProvider from './contexts/Banners';
import PopupsProvider from './contexts/Popups';
import { HUBS } from '~constants/signalR';

import Routes from './routes';

import '~config/momentExtended';
import '~config/yupExtending';

const App: FC = () => {
  useLoadGoogleApis();
  useLoadGoogleTagManager();
  useLoadTawk();

  return (
    <ReduxProvider store={store}>
      <ReduxPersistGateProvider loading={null} persistor={persitor}>
        <HistoryRouter history={appHistory}>
          <SignalRProvider url={HUBS.NOTIFICATION_HUB}>
            <MuiThemeProvider theme={theme}>
              <MuiCssBaseline />

              <SnackBarProvider>
                <MuiDatePickersLocalizationProvider
                  dateAdapter={AdapterDateFns}
                  adapterLocale={dateFnsEsLocale}
                >
                  <AlertsProvider>
                    <SubscriptionPaymentModalProvider>
                      <AccessFeatureModalProvider>
                        <BannersProvider>
                          <PopupsProvider>
                            <Routes />
                          </PopupsProvider>
                        </BannersProvider>
                      </AccessFeatureModalProvider>
                    </SubscriptionPaymentModalProvider>
                  </AlertsProvider>
                </MuiDatePickersLocalizationProvider>
              </SnackBarProvider>
            </MuiThemeProvider>
          </SignalRProvider>
        </HistoryRouter>
      </ReduxPersistGateProvider>
    </ReduxProvider>
  );
};

export default App;
